import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import { removeGrowlMessage } from 'messages/actions';
import { GrowlMessage } from 'messages/components';

class GrowlMessagesContainer extends PureComponent {
  static propTypes = {
    messages: PropTypes.object.isRequired,
  };

  render = () => {
    return this.props.messages ? (
      <Fragment>
        {Object.keys(this.props.messages).map((id) => (
          <GrowlMessage
            key={id}
            id={id}
            display={!!this.props.messages[id].text}
            title={this.props.messages[id].title && this.props.t(this.props.messages[id].title)}
            text={this.props.t(this.props.messages[id].text)}
            type={this.props.messages[id].type}
            handleRemove={this.props.removeMessage}
          />
        ))}
      </Fragment>
    ) : null;
  };
}

const mapStateToProps = (state, ownProps) => ({
  messages: state.message.growl,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  removeMessage: (id) => dispatch(removeGrowlMessage(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(translate()(GrowlMessagesContainer));



// WEBPACK FOOTER //
// src/modules/messages/containers/GrowlMessagesContainer.js